import pro1 from "../assets/Ezra-logo.png";
import pro2 from "../assets/Berry-logo.avif";
import pro3 from "../assets/Revo_logo.png";
import pro4 from "../assets/belimuno.png";

const ExperienceData = [
  {
    imgsrc: pro4,
    title: "BELIMUNO HR Outsourcing Solution",
    company: "BELIMUNO HR Outsourcing Solution",
    text: "As a Full Stack Developer at BELIMUNO HR Outsourcing Solution, I contributed to the development of a dynamic web application, leveraging Node.js for the backend and Next.js for creating interactive and user-friendly interfaces.",
    role: "Full-stack Developer",
    skills: "Next.js, Node.js, TypeScript, Express, MongoDB, Tailwind CSS",
    date: "Jul 2025 - Nov 2025",
    employmentType: "Freelance",
    locationType: "Remote",
    location: "Addis Ababa, Ethiopia",
    website: "https://belimunojobs.com/",
    github: "",
  },
  {
    imgsrc: pro3,
    title: "Revo Solutions",
    company: "Revo Solutions",
    text: "Developed and maintained responsive full-stack websites with React, Node.js, Express, and MySQL. Deployed and optimized projects on cPanel with seamless form integrations.",
    role: "Full-stack Developer",
    skills: "React, Node.js, Express, MySQL, cPanel",
    date: "Jan 2025 - May 2025",
    employmentType: "Full-time",
    locationType: "Onsite",
    location: "Addis Ababa, Ethiopia",
    website: "https://revosolutionplc.com/",
    github: "https://github.com/Revo-Solutions-PLC",
  },
  {
    imgsrc: pro2,
    title: "Berry Advertising",
    company: "Berry Advertising",
    text: "Built a Next.js-based frontend optimized for SEO and performance. Integrated Strapi CMS, multilingual support with i18n, and an interactive chatbot for user engagement.",
    role: "Full-stack Developer",
    skills: "Next.js, Strapi, React-Chatbot-Kit, i18n, Tailwind CSS",
    date: "Sep 2024 – Dec 2024",
    employmentType: "Contract",
    locationType: "Remote",
    location: "Addis Ababa, Ethiopia",
    website: "https://www.berryethiopia.com/",
    github: "",
  },
  {
    imgsrc: pro1,
    title: "EZRA Seminary",
    company: "EZRA Seminary",
    text: "I contributed to the development of dynamic web & mobile application, utilizing Node.js for scalable solutions, React for intuitive user interfaces, & React Native for mobile development. My contributions enhanced performance, maintained code quality, and fostered a collaborative team environment, driving project success. I also implemented software QA testing to ensure reliability of UI components and a consistent user experience.",
    role: "Full-stack Developer & QA Engineer",
    skills:
      "React, Node.js, Express, MongoDB, Redux, Tailwind CSS, Cypress, Postman, k6, Lighthouse, Linear, Trello, React Native",
    date: "Sep 2023 – Aug 2024",
    employmentType: "Full-time",
    locationType: "Remote",
    location: "Addis Ababa, Ethiopia",
    website: "https://ezraseminary.org/",
    github: "https://github.com/EzraSeminary",
  },
];

export default ExperienceData;
